import { render, staticRenderFns } from "./OrganisationPerformance.vue?vue&type=template&id=640dfe31"
import script from "./OrganisationPerformance.vue?vue&type=script&lang=js"
export * from "./OrganisationPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports